import { ManageableItemsList } from '@payaca/ambrosia';
import { FC, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

import useGetDocumentBlueprints from '@/api/queries/documentBlueprints/useGetDocumentBlueprints';

/**
 * Searchable table of the ready-made library. Rows link to the item's
 * preview page. Render a page title above it, not inside the card.
 */
export const DocumentBlueprintsTable: FC = () => {
  const history = useHistory();

  const { data, isLoading } = useGetDocumentBlueprints();
  const [searchTerm, setSearchTerm] = useState('');

  const blueprints = useMemo(() => {
    const all = data?.documentBlueprints ?? [];
    const term = searchTerm.trim().toLowerCase();
    if (!term) return all;
    return all.filter((blueprint) =>
      `${blueprint.name} ${blueprint.description ?? ''}`
        .toLowerCase()
        .includes(term)
    );
  }, [data, searchTerm]);

  return (
    <ManageableItemsList>
      <ManageableItemsList.ActionBar>
        <ManageableItemsList.ActionBar.SearchInput
          value={searchTerm}
          onChange={setSearchTerm}
        />
      </ManageableItemsList.ActionBar>
      <ManageableItemsList.Table
        uniqueKey="id"
        items={blueprints}
        isLoading={isLoading}
        emptyText={
          searchTerm
            ? `Nothing in the library matches "${searchTerm}"`
            : 'Nothing in the library right now'
        }
        onClickRow={(row) => {
          history.push(
            `/companySettings/custom-data/ready-made-library/${row.id}`
          );
        }}
      >
        <ManageableItemsList.Table.Column
          field="name"
          header="Name"
          className="w-1/2 whitespace-normal"
        />
        <ManageableItemsList.Table.Column
          field="description"
          header="Description"
          className="whitespace-normal"
          render={(description) => description ?? '-'}
        />
      </ManageableItemsList.Table>
    </ManageableItemsList>
  );
};
